// getFpIdPro.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';
import {
  FINGERPRINTJS_PRO_API_KEY,
  FINGERPRINTJS_PRO_ENDPOINT,
  FINGERPRINTJS_PRO_REGION,
} from '../RemoteConfigKeys.js';
import pushToastr from './pushToastr.js';
import { setHeader } from '../resource/fetchOptionHeader.js';
import trackMixpanel, { EventTypes } from '../resource/mixpanel.js';

const isProd = process.env.NODE_ENV === 'production';

/**
 * Get fp pro id
 * @kind action
 * @param {Object} params - The parameters object
 * @param {string} [params.via=''] - The source of the request
 * @returns {Promise<Object>} Redux action promise with fingerprint data
 */
const getFpIdPro =
  ({ via = '' } = {}) =>
  async (dispatch, getState) => {
    const state = getState();
    const userId = getMeData(state, 'id');
    const clientId = getMeData(state, 'clientId');
    const fpJsAPIKey = getRemoteConfigData(state, FINGERPRINTJS_PRO_API_KEY);
    const fpJsEndpoint = getRemoteConfigData(state, FINGERPRINTJS_PRO_ENDPOINT);
    const fpJsRegion = getRemoteConfigData(state, FINGERPRINTJS_PRO_REGION);

    try {
      const { initFpJsPro, getFpIdPro: getFpIdProFromIndexedDB } = await import(
        '../resource/fpjs.js'
      );

      await initFpJsPro({
        clientId,
        fpJsAPIKey,
        fpJsEndpoint,
        fpJsRegion,
        userId,
      });

      const fpIdPro = await getFpIdProFromIndexedDB();

      if (fpIdPro) {
        setHeader({
          key: 'X-Fingerprint-Pro-Id',
          value: fpIdPro,
        });

        trackMixpanel({
          type: EventTypes.USER_DEBUG_SENT,
          payload: {
            fingerprintData: {
              'id.pro': fpIdPro,
              via,
            },
          },
        });
      }

      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['fingerprint'],
          data: { fpIdPro: fpIdPro || '' },
        },
      });
    } catch (error) {
      if (!isProd) {
        return dispatch(
          pushToastr({
            textKey: error.message,
            color: 'error',
          })
        );
      }
    }
  };
export default getFpIdPro;
